<div>
  <div fxLayout="row wrap">
    <div class="store-dir" fxFlex.gt-sm="50" fxFlex.lt-sm="100">
      <div class="newsletter">
        <br />
        <br />
        <br />
        <div style="padding: 24px 16px">
          <h2>Store Directory</h2>
          <p>Find all the places where you can enjoy Zero guilt shopping.</p>
          <br />
        </div>
        <br />
        <br />
        <br />
      </div>
    </div>
    <div class="store-dir-cover" fxFlex.gt-sm="50" fxFlex.lt-sm="0"></div>
  </div>
  <section appScrollManager>
    <br />
    <h3 style="padding-left: 16px; padding-right: 16px; margin-top: 16px">
      Select a different category to see more!
    </h3>
    <div style="padding-left: 16px; padding-right: 16px; margin-top: 16px">
      <mat-chip-list>
        <mat-chip
          [ngClass]="{
            'selected-category': selectedChip == -1
          }"
          (click)="selectedChip = -1; buildActiveList()"
        >
          <ng-container *ngIf="selectedChip == -1">
            <mat-icon>check_circle</mat-icon>&nbsp;
          </ng-container>
          All</mat-chip
        >
        <mat-chip
          [ngClass]="{
            'selected-category': items.categoryID == selectedChip
          }"
          (click)="selectedChip = items.categoryID!; buildActiveList()"
          *ngFor="let items of stores"
        >
          <ng-container *ngIf="items.categoryID == selectedChip">
            <mat-icon>check_circle</mat-icon>&nbsp;
          </ng-container>
          {{ items.title }}</mat-chip
        >
      </mat-chip-list>
    </div>

    <br />
    <!-- [appScrollAnchor]="items.category.name" -->
    <div
      fxLayout="row wrap"
      fxLayoutAlign="stretch"
      *ngFor="let items of activeList"
    >
      <!-- [appScrollSection]="items.category.name" -->
      <div fxFlex.gt-sm="100" fxFlex.lt-sm="100" *ngIf="selectedChip == -1">
        <h3
          style="
            font-size: 18px;
            font-weight: bold;
            padding: 16px;
            margin: 0;
            color: #1a2759;
            margin-top: 16px;
          "
        >
          {{ items.title }}
        </h3>
      </div>
      <div
        fxFlex.gt-sm="20"
        fxFlex.lt-sm="100"
        class="partner-tile-container"
        *ngFor="let item of items.items"
      >
        <mat-card
          (click)="click(item.placementId!, item.websiteUrl!)"
          class="mat-elevation-z4 partner-tile"
          [style.background]="
            'linear-gradient(to right,rgba(255,255,255,0.7),rgba(255,255,255,0.7)),url(' +
            item.coverUrl +
            ')'
          "
        >
          <div class="partner-hover">
            <div>
              <br /><br />

              <h3>
                <strong *ngIf="item.isPhysicalStore">In-store</strong>

                <ng-container *ngIf="item.isPhysicalStore && item.isOnlineStore"
                  >&nbsp;|&nbsp;</ng-container
                >

                <strong *ngIf="item.isOnlineStore">Online</strong>
              </h3>
            </div>
          </div>

          <img class="img-logo" mat-card-image [lazyLoad]="item.logoUrl!" />
        </mat-card>
      </div>
    </div>
  </section>
</div>
